var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label !== '')?_c(_vm.tag,{tag:"component",class:[
        'SubTab',
        _vm.active && 'SubTab--active' ],attrs:{"role":"navigation","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('navigate', _vm.to)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }